import { View } from '@fairygodboss/ui';
import React, { useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import ModerationMenuV1 from './ModerationMenuV1';

const DeleteSVG = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <style jsx>
            {`
                .Admin-menu {
                    font-family: Lato, sans-serif;
                }
                .Admin-menu .title {
                    max-width: 400px;
                    margin: 10px;
                }
                .Admin-menu ul {
                    padding: 0;
                    margin: 1rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .Admin-menu .link {
                    margin: 10px;
                    padding: 5px;
                    width: 240px;
                }
                .Admin-menu .link:focus {
                    outline: none;
                }
                .Admin-menu .link a:hover {
                    color: white;
                }
                .Admin-menu .pt-1:focus {
                    outline: none;
                }
            `}
        </style>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2C8 1.44772 8.44772 1 9 1H11C11.5523 1 12 1.44772 12 2V3H15H17H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5H17V17C17 18.1046 16.1046 19 15 19H5C3.89543 19 3 18.1046 3 17V5H2C1.44772 5 1 4.55228 1 4C1 3.44772 1.44772 3 2 3H3H5H8V2ZM5 5L5 17H15V5H5ZM7 14.5C7 15.0523 7.44772 15.5 8 15.5C8.55228 15.5 9 15.0523 9 14.5V7.5C9 6.94771 8.55228 6.5 8 6.5C7.44772 6.5 7 6.94771 7 7.5V14.5ZM12 15.5C11.4477 15.5 11 15.0523 11 14.5V7.5C11 6.94771 11.4477 6.5 12 6.5C12.5523 6.5 13 6.94771 13 7.5V14.5C13 15.0523 12.5523 15.5 12 15.5Z"
            fill="#353535"
        />
    </svg>
);

const FlagSVG = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 2H8C9.30625 2 10.4175 2.83485 10.8293 4.00009L15 4C16.5977 4 17.9037 5.24892 17.9949 6.82373L18 7V13C18 14.5977 16.7511 15.9037 15.1763 15.9949L15 16H12C10.6941 16 9.58312 15.1656 9.17102 14.0009L4 14V17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2ZM11 6V13C11 13.5128 11.386 13.9355 11.8834 13.9933L12 14H15C15.5128 14 15.9355 13.614 15.9933 13.1166L16 13V7C16 6.48716 15.614 6.06449 15.1166 6.00673L15 6H11ZM8 4H4V12H9V5C9 4.48716 8.61396 4.06449 8.11662 4.00673L8 4Z"
            fill="#202532"
        />
    </svg>
);

const ElipseSVG = ({ color }) => (
    <svg
        width="4"
        height="20"
        viewBox="0 0 4 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1396_67234)">
            <circle
                cx="2"
                cy="18"
                r="2"
                transform="rotate(-90 2 18)"
                fill={color}
            />
            <circle
                cx="2"
                cy="10"
                r="2"
                transform="rotate(-90 2 10)"
                fill={color}
            />
            <circle
                cx="2"
                cy="2"
                r="2"
                transform="rotate(-90 2 2)"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_1396_67234">
                <rect
                    width="20"
                    height="4"
                    fill="white"
                    transform="translate(0 20) rotate(-90)"
                />
            </clipPath>
        </defs>
    </svg>
);

const EditSVG = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H17ZM6.29289 9.29289L13.2929 2.29289C13.6534 1.93241 14.2206 1.90468 14.6129 2.2097L14.7071 2.29289L17.7071 5.29289C18.0676 5.65338 18.0953 6.22061 17.7903 6.6129L17.7071 6.70711L10.7071 13.7071C10.5508 13.8634 10.3481 13.9626 10.1314 13.9913L10 14H7C6.48716 14 6.06449 13.614 6.00673 13.1166L6 13V10C6 9.77899 6.07316 9.56552 6.20608 9.39197L6.29289 9.29289L13.2929 2.29289L6.29289 9.29289ZM14 4.41421L8 10.4142V12H9.58579L15.5858 6L14 4.41421Z"
            fill="#202532"
        />
    </svg>
);

const DirectLinkSVG = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 2C1.89543 2 1 2.89543 1 4V12C1 13.1014 1.88978 14 2.99755 14H6V17C6 18.1046 6.89543 19 8 19H16C17.1046 19 18 18.1046 18 17V9C18 7.89543 17.1046 7 16 7H13V4C13 2.89543 12.1046 2 11 2H3ZM11 7V4L3 4V12H6V9C6 7.89543 6.89543 7 8 7H11ZM8 14H11L9.95284 14.9623C9.60783 15.3935 9.67775 16.0228 10.109 16.3678C10.5403 16.7128 11.1696 16.6429 11.5146 16.2117L14.0588 13.2529C14.2203 13.0649 14.2199 12.787 14.0577 12.5996L11.5704 9.72616C11.1799 9.33563 10.5467 9.33563 10.1562 9.72616C9.76565 10.1167 9.76565 10.7498 10.1562 11.1404L11 12.0013L8 12V9H16V17H8V14Z"
            fill="#353535"
        />
    </svg>
);

const SettingsSVG = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0066 3.85486L13.6685 4.25227C13.6685 4.25227 15.6448 3.89745 15.7597 3.88664C16.3577 3.81118 17.0018 4.14158 17.3026 4.67759L18.1321 6.15558C18.4342 6.69385 18.3909 7.43558 18.0413 7.90489C17.9602 8.02239 16.6754 9.60531 16.6754 9.60531C16.6754 9.60531 16.6835 9.72221 16.6835 9.99992C16.6835 10.1337 16.6723 10.4 16.6723 10.4C16.6723 10.4 17.9602 11.9774 18.0266 12.0743C18.3891 12.5694 18.4329 13.3083 18.1321 13.8443L17.3026 15.3222C17.0005 15.8606 16.3543 16.1928 15.7786 16.1154C15.7739 16.1149 13.6579 15.7465 13.6579 15.7465L13.0066 16.1415C13.0066 16.1415 12.3154 18.0801 12.2671 18.1877C12.0316 18.7581 11.4314 19.1666 10.8298 19.1666H9.17081C8.56655 19.1666 7.96379 18.757 7.74349 18.2108C7.68519 18.0799 6.99214 16.1344 6.99214 16.1344L6.32811 15.7449C6.32811 15.7449 4.35561 16.1025 4.24079 16.1133C3.64281 16.1887 2.99883 15.8582 2.69803 15.3222L1.86852 13.8443C1.56639 13.3059 1.60983 12.5641 1.95947 12.0948C2.04062 11.9773 3.32662 10.3931 3.32662 10.3931C3.32662 10.3931 3.31716 10.2777 3.31716 9.99992C3.31716 9.8687 3.32789 9.60761 3.32789 9.60761C3.32789 9.60761 2.04062 8.02251 1.97413 7.92564C1.61158 7.4306 1.56769 6.6916 1.86852 6.15558L2.69803 4.67759C3.00013 4.13932 3.64623 3.80707 4.2161 3.88382C4.35561 3.89736 6.34764 4.25432 6.34764 4.25432L7.00168 3.85435C7.00168 3.85435 7.68519 1.91997 7.73347 1.81236C7.96895 1.24186 8.56914 0.833252 9.17081 0.833252H10.8298C11.434 0.833252 12.0368 1.24273 12.2571 1.78879C12.3154 1.91977 13.0066 3.85486 13.0066 3.85486ZM11.5372 5.19142L11.4175 4.77951C11.2435 4.18056 10.7501 2.82267 10.6975 2.69557C10.667 2.6219 9.33357 2.62192 9.30311 2.69561C9.25056 2.82271 8.75727 4.18056 8.58325 4.77943L8.46356 5.19136L8.07913 5.36006C7.71587 5.51947 7.37279 5.72381 7.05712 5.96813L6.72267 6.22697L6.31546 6.12748C5.72388 5.98293 4.33317 5.74333 4.19979 5.7266C4.12248 5.71689 3.45574 6.90492 3.50256 6.96893C3.58334 7.07936 4.48029 8.19828 4.89766 8.65293L5.18429 8.96516L5.13453 9.39155C5.11112 9.59218 5.09931 9.79518 5.09931 9.9999C5.09931 10.2046 5.11112 10.4076 5.13453 10.6082L5.18429 11.0346L4.89766 11.3469C4.48029 11.8015 3.58334 12.9204 3.50256 13.0309C3.45574 13.0949 4.12248 14.2829 4.19979 14.2732C4.33317 14.2565 5.72388 14.0169 6.31546 13.8723L6.72267 13.7728L7.05712 14.0317C7.37279 14.276 7.71587 14.4803 8.07913 14.6397L8.46356 14.8084L8.58325 15.2204C8.75727 15.8192 9.25056 17.1771 9.30311 17.3042C9.33357 17.3779 10.667 17.3779 10.6975 17.3042C10.7501 17.1771 11.2435 15.8192 11.4175 15.2203L11.5372 14.8084L11.9216 14.6397C12.2848 14.4802 12.6279 14.2759 12.9436 14.0316L13.278 13.7727L13.6853 13.8722C14.2768 14.0167 15.6674 14.2564 15.8008 14.2731C15.8464 14.2789 16.5449 13.0949 16.4981 13.0308C16.4173 12.9204 15.5204 11.8014 15.1029 11.3467L14.8163 11.0345L14.8661 10.6081C14.8895 10.4075 14.9013 10.2046 14.9013 9.9999C14.9013 9.79524 14.8895 9.5923 14.8661 9.39172L14.8163 8.96535L15.1029 8.65313C15.5204 8.19842 16.4173 7.07939 16.4981 6.96896C16.5449 6.90494 15.8781 5.71695 15.8008 5.72666C15.6674 5.74341 14.2768 5.98307 13.6853 6.1276L13.278 6.2271L12.9436 5.96823C12.6279 5.7239 12.2848 5.51955 11.9216 5.36013L11.5372 5.19142ZM10.0003 12.7499C8.52392 12.7499 7.32706 11.5187 7.32706 9.99992C7.32706 8.48113 8.52392 7.24992 10.0003 7.24992C11.4767 7.24992 12.6736 8.48113 12.6736 9.99992C12.6736 11.5187 11.4767 12.7499 10.0003 12.7499ZM10.0003 10.9166C10.4924 10.9166 10.8914 10.5062 10.8914 9.99994C10.8914 9.49368 10.4924 9.08328 10.0003 9.08328C9.50815 9.08328 9.10919 9.49368 9.10919 9.99994C9.10919 10.5062 9.50815 10.9166 10.0003 10.9166Z"
            fill="#353535"
        />
    </svg>
);

const UpArrowSVG = () => (
    <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.96934 7.5919C1.51884 8.02874 0.788447 8.02874 0.337951 7.5919C-0.112545 7.15506 -0.112545 6.44679 0.337951 6.00995L6.18437 0.4082C6.63487 -0.0286447 7.36527 -0.0286447 7.81576 0.4082L13.6622 6.00995C14.1127 6.44679 14.1127 7.15506 13.6622 7.5919C13.2117 8.02874 12.4813 8.02874 12.0308 7.5919L7.00007 2.78113L1.96934 7.5919Z"
            fill="#353535"
        />
    </svg>
);

const DownArrowSVG = () => (
    <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.0307 0.4081C12.4812 -0.0287442 13.2116 -0.0287442 13.662 0.4081C14.1125 0.844944 14.1125 1.55321 13.662 1.99005L7.81563 7.5918C7.36513 8.02864 6.63473 8.02864 6.18424 7.5918L0.337792 1.99005C-0.112703 1.55321 -0.112703 0.844944 0.337792 0.4081C0.788288 -0.0287442 1.51869 -0.0287442 1.96919 0.4081L6.99993 5.21887L12.0307 0.4081Z"
            fill="#353535"
        />
    </svg>
);

const engagementColors = {
    normal: '#999999',
    hover: '#353535',
};

const svgURL = (component, state) => {
    const color = engagementColors[state] || engagementColors.normal;

    const components = {
        up: <UpArrowSVG />,
        down: <DownArrowSVG />,
        settings: <SettingsSVG />,
        link: <DirectLinkSVG />,
        ellipse: <ElipseSVG color={color} />,
        edit: <EditSVG />,
        flag: <FlagSVG />,
        delete: <DeleteSVG />,
    };

    const url = `url("data:image/svg+xml,${encodeURIComponent(
        renderToStaticMarkup(components[component])
    )}")`;
    return url;
};

export const StyledModerationMenu = ({
    hash,
    type,
    location,
    handleOnEditClick,
    editboxShowing,
    isAdmin,
    ...others
}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    // hide moderation menu for regular users seeing articles/ podcasts
    const userEditorialView = !isAdmin
        && (type === 'editorial-content' || type === 'community-podcast');

    return !userEditorialView ? (
        <View
            pr={{ _: '0px', md: '12px' }}
            position={{ _: 'absolute', md: 'inherit' }}
            right="4px"
            {...others}
            css={{}}
        >
            <style jsx global>
                {`
                    .Admin-menu {
                        font-family: Lato, sans-serif;
                    }
                    .Admin-menu .title {
                        max-width: 400px;
                        margin: 10px;
                    }
                    .Admin-menu ul {
                        padding: 0;
                        margin: 1rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .Admin-menu .link {
                        margin: 10px;
                        padding: 5px;
                        width: 240px;
                    }
                    .Admin-menu .link:focus {
                        outline: none;
                    }
                    .Admin-menu .link a:hover {
                        color: white;
                    }
                    .Admin-menu .pt-1:focus {
                        outline: none;
                    }
                    .moderationMenu-content {
                        margin-top: 10px !important;
                        width: 160px !important;
                        boxshadow: 0px 4px 8px rgba(53, 53, 53, 0.2) !important;
                        border-radius: 6px !important;
                        border: none;
                    }
                    .component-Community-ModerationMenu-ModerationDirectLink {
                        background-repeat: no-repeat;
                        padding-left: 28px;
                        background-image: ${svgURL('link')};
                        background-position-y: 3px;
                        background-position-x: 2px;
                        text-transform: capitalize;
                    }
                    .component-Community-ModerationMenu-ModerationDirectLink
                        svg {
                        display: none;
                    }
                    .component-ModerationAdmin {
                        background-repeat: no-repeat;
                        padding-left: 20px;
                        background-image: ${svgURL('settings')};
                        background-position-y: 9px;
                        background-position-x: 0px;
                        text-transform: capitalize;
                    }
                    .component-ModerationAdmin svg {
                        display: none;
                    }
                    .component-ModerationEdit {
                        background-repeat: no-repeat;
                        padding-left: 30px;
                        background-image: ${svgURL('edit')};
                        background-position-y: 9px;
                        background-position-x: 2px;
                        text-transform: capitalize;
                    }
                    .component-ModerationEdit svg {
                        display: none;
                    }
                    .component-ModerationFlag {
                        background-repeat: no-repeat;
                        padding-left: 29px;
                        background-image: ${svgURL('flag')};
                        background-position-y: 9px;
                        background-position-x: 2px;
                        text-transform: capitalize;
                    }
                    .component-ModerationFlag svg {
                        display: none;
                    }
                    .component-ModerationDelete {
                        background-repeat: no-repeat;
                        padding-left: 30px;
                        background-image: ${svgURL('delete')};
                        background-position-y: 9px;
                        background-position-x: 2px;
                        text-transform: capitalize;
                    }
                    .component-ModerationDelete svg {
                        display: none;
                    }

                    .moderationMenu-item {
                        padding-left: 18px !important;
                    }
                    .moderationMenu-item svg {
                        display: none;
                    }
                    .moderationMenu-item:hover {
                        background-color: #f0f2f5 !important;
                        font-weight: 600 !important;
                    }
                    .component-Dots {
                        display: none;
                    }
                    .component-ModerationMenu .moderationMenu-button {
                        display: inline-block;
                        border: none;
                        text-decoration: none;
                        cursor: pointer;
                        background: none;
                    }

                    .component-ModerationMenu .moderationMenu-button:focus {
                        outline: none;
                    }
                    .component-ModerationMenu .moderationMenu-button {
                        background-image: ${svgURL(
            'ellipse',
            menuOpen && 'hover'
        )};
                        background-position-x: 12px !important;
                        background-repeat: no-repeat !important;
                        font-family: Open Sans !important;
                        font-style: normal;
                        height: 28px;
                        width: 28px;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                    }
                    .component-ModerationMenu .moderationMenu-button svg {
                        display: none;
                    }
                    .component-ModerationMenu .moderationMenu-button:hover {
                        background-image: ${svgURL(
            'ellipse',
            menuOpen && 'hover'
        )};
                        background-position-x: 12px !important;
                        background-repeat: no-repeat !important;
                        font-family: Open Sans !important;
                        font-style: normal;
                        height: 28px;
                        width: 28px;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                    }

                    .component-ModerationMenu {
                        width: auto;
                        height: auto;
                    }
                    .component-ModerationMenu .compoent-Dots {
                        display: none;
                    }
                    .component-ModerationMenu .active.component-Dots svg {
                        display: none !important;
                    }
                `}
            </style>
            <ModerationMenuV1
                hash={hash}
                type={type}
                onMenuClick={setMenuOpen}
                disableDelete={!handleOnEditClick}
                location={location}
                handleOnEditClick={handleOnEditClick}
                editboxShowing={editboxShowing}
            />
        </View>
    ) : null;
};
